import { OpenClubListing, RequestedListing } from "../../types";

const matchesRequestedListing = (
  listing: OpenClubListing,
  requestedListing: RequestedListing
) => {
  return (
    requestedListing.id === listing.ListingId ||
    requestedListing.title === listing.DisplayName ||
    requestedListing.clubName === listing.DisplayName ||
    requestedListing.clubName === listing.ClubName
  );
};

export const getDefaultSelectedOpenClubListingIds = (
  openClubListings: OpenClubListing[],
  requestedListings: RequestedListing[]
) => {
  return openClubListings
    .filter((listing) =>
      requestedListings.some((requestedListing) =>
        matchesRequestedListing(listing, requestedListing)
      )
    )
    .map((listing) => listing.ListingId);
};
